import { ChatItemAssistantTaskContainerProps } from './chatAssistantTaskProps';
import { ChatItemAssistantTaskController, ChatItemAssistantTaskLoader } from './chatAssistantTaskInterface';
import { ReportingShellContainerBaseConfig } from '../../../../base';
import React from 'react';

export function createChatItemAssistantTaskContainer(
    config: ReportingShellContainerBaseConfig,
    loader: ChatItemAssistantTaskLoader,
    controller: ChatItemAssistantTaskController
): React.FC<ChatItemAssistantTaskContainerProps> {
    const {
        repository: { research: repository },
        context: { useContext },
        pubsub: { router },
    } = config;

    return ({ as: View, item, ...containerProps }) => {
        const context = useContext();
        const data = loader.useLoad(context, { item });
        const props = controller.useProps(context, data, {});
        React.useEffect(() => {
            if(data.task?.status === 'completed') {
                router.dispatch({
                    kind: 'assistant_task_completed',
                    data: {
                        taskId: data.task.id,
                        status: 'success'
                    },
                })
            } else if (data.task?.status === 'failed') {
                router.dispatch({
                    kind: 'assistant_task_completed',
                    data: {
                        taskId: data.task.id,
                        status: 'failure'
                    },
                })
            }
        }, [data.task?.id, data.task?.status]);
        return <View {...props} />;
    };
}
